<template>
    <div class="modal-mask">

        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <slot name="header">

                        <h3 class="form-header">
                           My Health Record
                        </h3>
                        <button @click="closeModal" class="red-close-button">
                            <i class="pi pi-times" style="padding: 0;"></i>
                        </button>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body">
                        <Files :patient="this.patient" :miniView="miniView" />
                    </slot>
                </div>

                <!-- <div class="modal-footer">
                    <slot name="footer">
                        footer
                    </slot>
                </div> -->

            </div>

        </div>

    </div>
</template>

<script>
import Files from './Files.vue';

export default {
    props: ['patient'],
    emits: ['close'],
    components: {
        Files
    },
    data() {
        return {
            inputAccessCode: '',
            actionType: 'print',
            uploadChecked: false,
            from: '',
            to: '',
            miniView: true
        }
    },
    methods: {
        validateDates() {
            if (this.from && this.to && this.from > this.to) {
                const temp = this.from;
                this.from = this.to;
                this.to = temp;
            }
        },
        closeModal() {
            console.log('hitting this closemodal function')
            this.$emit('close');
        },
        acceptAction(type) {
            if (this.uploadFile) {
                const action = {
                    type: this.actionType,
                    file: this.supersedeFile?.documentId
                };
                // also pass in selected file here this.supersedefile
                this.$emit('action', action);
            } else if (this.accessCode) {
                console.log("accepting action .....");
                // generic action - can take payload or not depend on parent "action" fn
                const payload = {
                    access_type: type === "emergencyAccess" ? "emergency" : "AccessCode",
                    access_code: this.inputAccessCode
                };
                this.$emit('action', payload);
            } else if (this.additionalFilterStatus) {
                const payload = {
                    from: this.from,
                    to: this.to
                };
                console.log("this is date fitler ", payload);
                this.$emit('action', payload);
            } else if (this.removeFile) {
                this.$emit('action');
            }
        },
        setActionType(actionType) {
            this.actionType = actionType
        },
    },
    mounted() {
        console.log("this is miniView , ",this.miniView);
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.action-description {
    white-space: pre-wrap;
    text-align: left;
    font-size: 16px;
}

.modal-body {
    padding-left: 20px;
}

.modal-container {
    min-width: 480px;
    width: 20%;
}

.disabled-button {
    opacity: 0.5;
    cursor: not-allowed;
}

.date-range-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    width: 100%;
}

.date-selector {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.date-selector label {
    margin-bottom: 5px;
    font-weight: bold;
}

.date-selector input {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
}
.modal-mask {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: table;
    transition: opacity 0.3s ease;
    overflow: hidden;
    position:fixed;
    height: 100%;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    position: relative;
}


.modal-container {
    width: 80%;
    min-width: 1000px;
    max-height: 78vh;
    overflow: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;
    margin: 0px auto;
    padding: 3px 3px;
    background-color: white;
    border-radius: 8px;
    transition: all 0.3s ease;
}


.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px !important;
    padding-top: 10px !important;
}

.modal-footer {
    display: flex;
    justify-content: center;
    background-color: white;
    padding: 20px;
    padding-top: 0x;
    height: 4em;
    align-items: center;
}

.modal-container::-webkit-scrollbar {
    display: none;
}
</style>
